import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { faBallotCheck } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { BlockTypes } from 'enum'
import * as fromActions from 'store/actions/blocks.action'
import BlockTypeButton from '../block-type-button/BlockTypeButton'

interface EvaluationButtonProps {
  lessonId: number
  totalBlocks: number
  hasEvaluation: boolean
  onSelect: (option: BlockTypes) => void
}

export const EvaluationButton = ({
  hasEvaluation,
  onSelect,
}: EvaluationButtonProps) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  return (
    <BlockTypeButton
      variant="evaluation"
      text={t('administration.blocks.type.evaluation.name')}
      icon={<FontAwesomeIcon icon={faBallotCheck} />}
      disabled={hasEvaluation}
      onClick={async () => {
        dispatch(
          fromActions.Actions.editBlockInstance({
            blockType: BlockTypes.Evaluation,
          })
        )
        onSelect(BlockTypes.Evaluation)
      }}
    />
  )
}
